import { render, staticRenderFns } from "./BookSearchFiltersSidebar.vue?vue&type=template&id=0f19d339&scoped=true&"
import script from "./BookSearchFiltersSidebar.vue?vue&type=script&lang=js&"
export * from "./BookSearchFiltersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BookSearchFiltersSidebar.vue?vue&type=style&index=0&id=0f19d339&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19d339",
  null
  
)

export default component.exports